import m from "../../geodata/es2015/chinaLow";
window.am4geodata_chinaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chinaLow.js
// module id = null
// module chunks = 